<template>
  <table class="table table-sm">
    <thead>
    <tr>
      <th scope="col">
        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Attack bonus" alt="Attack bonus" src="/static/images/icons/attack.png">
      </th>
      <th scope="col">
        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Defence bonus" alt="Defence bonus" style="min-height: 25px"
             src="/static/images/icons/defence.png">
      </th>
      <th scope="col">
        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Other bonus" alt="Other bonus" src="/static/images/icons/defence_stats.png">
      </th>
    </tr>
    </thead>

    <tbody>
    <tr>
      <td>
        <PlayerStat class="col-12" :icon="'stab'" :value="this.ts.attack_stab"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12" :icon="'stab'" :value="this.ts.defence_stab"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12" :icon="'melee_strength'" :value="this.ts.melee_strength"></PlayerStat>
      </td>
    </tr>

    <tr>
      <td>
        <PlayerStat class="col-12" :icon="'crush'" :value="this.ts.attack_crush"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12" :icon="'crush'" :value="this.ts.defence_crush"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12 " :icon="'ranged_strength'"
                    :value="this.ts.ranged_strength"></PlayerStat>
      </td>
    </tr>

    <tr>
      <td>
        <PlayerStat class="col-12" :icon="'slash'" :value="this.ts.attack_slash"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12" :icon="'slash'" :value="this.ts.defence_slash"></PlayerStat>
      </td>

      <td>
        <PlayerStat class="col-12" :icon="'magic_damage'" :value="this.ts.magic_damage"></PlayerStat>
      </td>
    </tr>

    <tr>
      <td>
        <PlayerStat class="col-12" :icon="'magic'" :value="this.ts.attack_magic"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12" :icon="'magic'" :value="this.ts.defence_magic"></PlayerStat>
      </td>
    </tr>

    <tr>
      <td>
        <PlayerStat class="col-12" :icon="'ranged'" :value="this.ts.attack_ranged"></PlayerStat>
      </td>
      <td>
        <PlayerStat class="col-12" :icon="'ranged'" :value="this.ts.defence_ranged"></PlayerStat>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  import PlayerStat from "../PlayerStat";

  export default {
    name: "EquipmentBonusTable",
    components: {PlayerStat},
    props: {
      equipment: {
        type: Object,
        default: function () {
          return {
            head: {id: 0},
            cape: {id: 0},
            neck: {id: 0},
            ammo: {id: 0},
            weapon: {id: 0},
            body: {id: 0},
            shield: {id: 0},
            legs: {id: 0},
            hands: {id: 0},
            feet: {id: 0},
            ring: {id: 0},
          }
        }
      },
    },
    data() {
      return {
        showAdvanced: false,
      }
    },
    computed: {
      ts: function () {
        return this.calculateTotal();
      }
    },
    methods: {
      toHuman: function (str) {
        return str.replace('_', ' ')
      },

      calculateTotal: function () {
        let total = {
          attack_stab: 0,
          attack_slash: 0,
          attack_crush: 0,
          attack_magic: 0,
          attack_ranged: 0,

          defence_stab: 0,
          defence_slash: 0,
          defence_crush: 0,
          defence_magic: 0,
          defence_ranged: 0,

          melee_strength: 0,
          ranged_strength: 0,
          magic_damage: 0,
          prayer: 0,
        };

        for (let [key, item] of Object.entries(this.equipment)) {
          if (item.id === 0) {
            // console.log(`calculateTotal - Skipping ${key} - ${item.id} - invalid id`);
            continue;
          }

          total = this.addStats(total, item.equipment)
        }

        return total
      },

      addStats: function (current, add) {
        // console.log('addStats', [current, add]);

        return {
          attack_stab: current.attack_stab + add.attack_stab,
          attack_slash: current.attack_slash + add.attack_slash,
          attack_crush: current.attack_crush + add.attack_crush,
          attack_magic: current.attack_magic + add.attack_magic,
          attack_ranged: current.attack_ranged + add.attack_ranged,

          defence_stab: current.defence_stab + add.defence_stab,
          defence_slash: current.defence_slash + add.defence_slash,
          defence_crush: current.defence_crush + add.defence_crush,
          defence_magic: current.defence_magic + add.defence_magic,
          defence_ranged: current.defence_ranged + add.defence_ranged,

          melee_strength: current.melee_strength + add.melee_strength,
          ranged_strength: current.ranged_strength + add.ranged_strength,
          magic_damage: current.magic_damage + add.magic_damage,
          prayer: current.prayer + add.prayer,
        };
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gear-selector/EquipmentBonusTable.vue